import { useState, useEffect } from 'react';
import { getAllActiveUsers } from '../services/userManagementservice';

export const useActiveUsers = (alertId) => {
    const[activeUsers, setActiveUsers] = useState([]);
    
    // useEffect(() => {
    //     getUsers(alertId);
    // }, [alertId]);

    const getUsers = async (alertId) => {
        try {
            await getAllActiveUsers(alertId).then((resp) => {
                if(resp.Status === "success"){
                    setActiveUsers(resp.Data);
                } 
            })
        } catch (error) {
            console.error(error)
        }
    }

    return { activeUsers, getUsers, setActiveUsers };
}